import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/views/index'; //
import Location from '@/views/location/location'; //定位页面
import tokenVerify from '@/utils/lib/token-verify'; //token验证

Vue.use(Router);

let router = new Router({
    base: process.env.BASE_URL,
    routes: [{
            path: '',
            redirect: '/deviceOption'
        },
        {
            path: '/index',
            component: Index,
            children: [{
                    path: '',
                    redirect: '/location'
                },
                {
                    path: '/location',
                    name: 'location',
                    component: Location,
                    meta: {
                        title: '定位',
                        keepAlive: false
                    }
                },
                {
                    path: '/footprint',
                    name: 'footprint',
                    component: () =>
                        import ('@/views/footprint/footprint'),
                    meta: {
                        title: '足迹',
                        keepAlive: false
                    }
                },
                {
                    path: '/message',
                    name: 'message',
                    component: () =>
                        import ('@/views/message/message'),
                    meta: {
                        title: '消息',
                        keepAlive: false
                    }
                },
                {
                    path: '/more',
                    name: 'more',
                    component: () =>
                        import ('@/views/more/more'),
                    meta: {
                        title: '更多',
                        keepAlive: false
                    }
                }
            ]
        },
        {
            path: '/waterSafety',
            name: 'waterSafety',
            component: () =>
                import ('@/views/water-safety/index'), // 安全水域
            meta: {
                title: '安全水域',
                keepAlive: false
            }
        },
        {
            path: '/updateInfo',
            name: 'updateInfo',
            component: () =>
                import ('@/views/more/update-info'), // 修改宝贝名片
            meta: {
                title: '修改宝贝名片',
                keepAlive: false
            }
        },
        {
            path: '/safetyFence',
            name: 'safetyFence',
            component: () =>
                import ('@/views/safety-fence/safety-fence'), // 安全区域
            meta: {
                title: '安全区域',
                keepAlive: false
            }
        },
        {
            path: '/addFence',
            name: 'addFence',
            component: () =>
                import ('@/views/safety-fence/add-fence'), // 添加安全区域
            meta: {
                title: '安全区域',
                keepAlive: false
            }
        },
        {
            path: '/deviceAlarm',
            name: 'deviceAlarm',
            component: () =>
                import ('@/views/message/deviceAlarm'), // 设备消息
            meta: {
                title: '设备消息',
                keepAlive: false
            }
        },
        {
            path: '/fenceAlarm',
            name: 'fenceAlarm',
            component: () =>
                import ('@/views/message/fenceAlarm'), // 指定区域进出提醒
            meta: {
                title: '围栏进出提醒',
                keepAlive: false
            }
        },
        {
            path: '/sosAlarm',
            name: 'sosAlarm',
            component: () =>
                import ('@/views/message/sosMessage'), // SOS消息提醒
            meta: {
                title: 'SOS消息提醒',
                keepAlive: false
            }
        },
        {
            path: '/sosDetail',
            name: 'sosDetail',
            component: () =>
                import ('@/views/message/sos-distress'), // sos求救位置显示
            meta: {
                title: 'SOS求救',
                keepAlive: false
            }
        },
        {
            path: '/mailList',
            name: 'mailList',
            component: () =>
                import ('@/views/mail-list/mail-list'), // 通讯录
            meta: {
                title: '通讯录',
                keepAlive: false
            }
        },
        {
            path: '/addMail',
            name: 'addMail',
            component: () =>
                import ('@/views/mail-list/components/add'), // 新增通讯录
            meta: {
                title: '新增',
                keepAlive: false
            }
        },
        {
            path: '/sosSet',
            name: 'sosSet',
            component: () =>
                import ('@/views/sos-set/sos-set'), // sos设置
            meta: {
                title: 'SOS设置',
                keepAlive: false
            }
        },
        {
            path: '/familyNumber',
            name: 'familyNumber',
            component: () =>
                import ('@/views/family-number/family-number'), // 亲情号
            meta: {
                title: '亲情号',
                keepAlive: false
            }
        },
        {
            path: '/noDisturbing',
            name: 'noDisturbing',
            component: () =>
                import ('@/views/no-disturbing/no-disturbing'), // 上课免打扰
            meta: {
                title: '上课免打扰',
                keepAlive: false
            }
        },
        {
            path: '/timeBucket',
            name: 'timeBucket',
            component: () =>
                import ('@/views/no-disturbing/time-bucket'), // 免打扰时段
            meta: {
                title: '编辑免打扰时段',
                keepAlive: false
            }
        },
        {
            path: '/dateOption',
            name: 'dateOption',
            component: () =>
                import ('@/views/no-disturbing/date-option'), // 免打扰时段
            meta: {
                title: '上课免打扰',
                keepAlive: false
            }
        },
        {
            path: '/shutdown',
            name: 'shutdown',
            component: () =>
                import ('@/views/shutdown/shutdown'), // 设备远程关机或设备远程重启
            meta: {
                title: '设备指令',
                keepAlive: false
            }
        },
        {
            path: '/myCamera',
            name: 'myCamera',
            component: () =>
                import ('@/views/myCamera/my-camera'), // 添加设备扫码
            meta: {
                title: '添加设备',
                keepAlive: false
            }
        },
        {
            path: '/myCamera1',
            name: 'myCamera1',
            component: () =>
                import ('@/views/myCamera/my-camera1'), // 添加设备扫码
            meta: {
                title: '添加设备',
                keepAlive: false
            }
        },
        {
            path: '/addDevice',
            name: 'addDevice',
            component: () =>
                import ('@/views/myCamera/index'), // 添加设备
            meta: {
                title: '添加设备',
                keepAlive: false
            }
        },
        {
            path: '/updateDevice',
            name: 'updateDevice',
            component: () =>
                import ('@/views/myCamera/update-device'), // 更换设备
            meta: {
                title: '更换设备',
                keepAlive: false
            }
        },
        {
            path: '/deviceOption',
            name: 'deviceOption',
            component: () =>
                import ('@/views/device-option/device-option'), // 设备列表
            meta: {
                title: '设备列表',
                keepAlive: false
            }
        },
        {
            path: '/contextual',
            name: 'contextual',
            component: () =>
                import ('@/views/contextual/index'), // 情景模式
            meta: {
                title: '情景模式',
                keepAlive: false
            }
        },
        {
            path: '/addVoice',
            name: 'addVoice',
            component: () =>
                import ('@/views/messageVoice/addVoice/index'), // 新增短消息
            meta: {
                title: '新增短消息',
                keepAlive: false
            }
        },
        {
            path: '/voiceList',
            name: 'voiceList',
            component: () =>
                import ('@/views/messageVoice/voiceList/index'), // 短消息列表
            meta: {
                title: '短消息列表',
                keepAlive: false
            }
        },
        {
            path: '/alarmDateOption',
            name: 'alarmDateOption',
            component: () =>
                import ('@/views/alarmClock/dateOption/index'), // 闹钟日期选择
            meta: {
                title: '重复',
                keepAlive: false
            }
        },
        {
            path: '/alarmCheckDate',
            name: 'alarmCheckDate',
            component: () =>
                import ('@/views/alarmClock/checkDate/index'), // 闹钟详情
            meta: {
                title: '编辑闹钟',
                keepAlive: false
            }
        },
        {
            path: '/alarmClock',
            name: 'alarmClock',
            component: () =>
                import ('@/views/alarmClock/index/index'), // 闹钟列表
            meta: {
                title: '闹钟设置',
                keepAlive: false
            }
        },
        {
            path: '/callLog',
            name: 'callLog',
            component: () =>
                import ('@/views/callLog/index'), // 通话记录
            meta: {
                title: '通话记录',
                keepAlive: false
            }
        },
    ]
});

router.beforeEach((to, from, next) => {
    // window.scrollTo(0, 0)
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = "电子学生证";
    }
    // tokenVerify(to.query.token); //验证token是否存在

    next();
});

export default router;